import api from '../api/endpoints'
import FileSaver from 'file-saver'

export default {
  methods: {
    generateReport (params) {
      this.$http.post(api.GENERATE_REPORT, {}, { params })
        .then(({data}) => this.download(data))
        .catch(console.log)
    },
    download ({ blob, mimeType, originalName }) {
      const byteCharacters = atob(blob)
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      const fileBlob = new Blob(byteArrays, {type: mimeType})
      FileSaver.saveAs(fileBlob, originalName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ReportMixin.js